import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import type { Product } from 'reactApp/types/Billing';

export const useOverquotaSpecificTariffs = getFeature('use-overquota-tarriff');

export const overquotaFlexibleTariffsDown = getFeature('overquota-flexible-tariffs-down');
export const overquotaFlexibleTariffsUp = getFeature('overquota-flexible-tariffs-up');

type TariffList = {
    year?: string[];
    month: string[];
};

export const tariffOverquotaList: TariffList = getFeature('tariff-overquota-list') || {
    month: [
        'W256GB_1m_landing_segmentation_main',
        'W512GB_1m_landing_segmentation_main',
        'W1TB_1m_landing_segmentation_main',
        'W2TB_1m_landing_segmentation_main',
    ],
};

const allFlexibleOverquotaTariffsRegex: string[] = getFeature('overquota-flex-tariffs-regex') || [
    'W(.*)(?:GB|TB)_(.*)_overquota_sale_discount_(.*)',
];
const parsedProductIdRegex = allFlexibleOverquotaTariffsRegex.map((r) => new RegExp(r));
const parseProductId = (product: Product) => {
    const {
        id,
        space: { space },
        period,
        isFamily,
    } = product;
    for (const r of parsedProductIdRegex) {
        const match = id.match(r);
        if (match) {
            return `trg-${match.slice(1).join('-')}`;
        }
    }
    return `oth-${space}-${period}${isFamily ? '-f' : ''}`;
};

if (overquotaFlexibleTariffsDown || overquotaFlexibleTariffsUp) {
    registerExperiment(
        `flx${overquotaFlexibleTariffsDown ? 'd' : 'u'}`,
        overquotaFlexibleTariffsDown || overquotaFlexibleTariffsUp || '',
        [
            AnalyticEventNames.TARIFF_CLICK,

            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
            AnalyticEventNames.TARIFF_BUY,
            AnalyticEventNames.TARIFF_CLOSE,
        ],
        {
            sendXrayArgs: {
                TARIFF_CLICK: ({ product }) => {
                    const shortcut = parseProductId(product);
                    return { eventName: `click-${shortcut}` };
                },

                FAST_CHECKOUT_SHOWN: ({ product }) => {
                    if (!product) {
                        return { cancel: true };
                    }
                    const shortcut = parseProductId(product);
                    return { eventName: `show-${shortcut}` };
                },

                TARIFF_BUY: ({ product }) => {
                    const shortcut = parseProductId(product);
                    return { eventName: `buy-${shortcut}` };
                },

                TARIFF_CLOSE: ({ product }) => {
                    const shortcut = parseProductId(product);
                    return { eventName: `close-${shortcut}` };
                },
            },
        }
    );
}
